import { UserBusinessFeatures } from '../entity/business-features.entity';
export class CAMarket implements UserBusinessFeatures {
  getUserAddressFeatures() {
    return {
      showApartmentBeforeStreet: false,
    };
  }
}
